export const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    INR: '₹',
    JPY: '¥',
    AUD: 'A$',
    CAD: 'C$',
    CHF: 'CHF',
    CNY: '¥',
    RUB: '₽',
    KRW: '₩',
    SGD: 'S$',
    ZAR: 'R',
    BRL: 'R$',
    MXN: '$',
    AED: 'د.إ',
    HKD: 'HK$',
    NZD: 'NZ$',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    TRY: '₺',
    THB: '฿',
    MYR: 'RM',
    IDR: 'Rp',
    PHP: '₱',
    PLN: 'zł',
    VND: '₫',
};